import { dateTimeLabel } from '../mapping.js';

/** 운영 공지 종류 표시(계획 문서 5.3 3b) — 이름·배지 색·알림 줄 심각도. 무엇이 지금 보이는지는 서버가 정한다 */
export const OPS_KIND = {
  incident: { label: '장애', tone: 'crit', severity: 'crit' },
  maintenance: { label: '점검', tone: 'warn', severity: 'warn' },
  release: { label: '배포', tone: 'info', severity: 'info' },
  notice: { label: '안내', tone: 'neutral', severity: 'info' }
};

/** 기간 표시 — 끝이 없으면 '부터'(브라우저 시간대 — 3d에서 앱 시간대로) */
export const opsPeriod = (o) => dateTimeLabel(o.starts_at) + (o.ends_at ? ' ~ ' + dateTimeLabel(o.ends_at) : ' 부터');
